// BR-10 (мост Telegram ↔ ТелеЧат, D-12): как показывать сообщение, пришедшее извне (`Message.origin`).
// design-system знает только общий проп `originLabel` (guard design-system не пускает туда название
// внешнего мессенджера); конкретные слова — здесь, в app-ui.

import type { Message, UserId } from '@tele-chat/shared-contracts'

import { strings } from '../i18n/strings.js'

/** Пришло извне (мост): люди в ТелеЧате его не правят и не удаляют «у всех» (messaging BR-4). */
export function isExternal(message: Pick<Message, 'origin'>): boolean {
  return message.origin !== undefined
}

/** Подпись происхождения в мете пузыря: «из Telegram» — у любого сообщения с origin. */
export function originLabelOf(message: Pick<Message, 'origin'>): string | undefined {
  return message.origin !== undefined ? strings.message.fromTelegram : undefined
}

/**
 * Имя автора над пузырём. Сообщение от служебной учётки моста (автор в Telegram не сопоставлен с
 * сотрудником) несёт `origin.authorName` — показываем его с пометкой « (Telegram)», а не «Telegram».
 */
export function senderDisplayName(
  message: Pick<Message, 'origin' | 'senderId'>,
  resolveName: (id: UserId) => string,
): string {
  const author = message.origin?.authorName
  return author !== undefined && author.length > 0
    ? `${author}${strings.message.externalAuthorSuffix}`
    : resolveName(message.senderId)
}

/**
 * Ключ «одного автора» для склейки пузырей: у служебной учётки моста разные люди из Telegram
 * различаются по `origin.authorName` (иначе подряд идущие Пётр и Вася склеились бы под одним именем).
 */
export function authorKeyOf(message: { senderId: UserId; origin?: Message['origin'] }): string {
  const author = message.origin?.authorName
  return author !== undefined ? `${message.senderId}\u0000${author}` : String(message.senderId)
}
